import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import App from "./App";
import * as Neutralino from '@neutralinojs/lib';

const CLERK_PUBLISHABLE_KEY = (import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string) || "pk_test_Z2VuZXJvdXMtY2ljYWRhLTkuY2xlcmsuYWNjb3VudHMuZGV2JA";

if (typeof window !== 'undefined' && (window as any).NL_TOKEN && !(window as any).isNeutralinoInitialized) {
  try {
    Neutralino.init();
    (window as any).isNeutralinoInitialized = true;
    console.log("Neutralino conectado nativamente de forma segura.");
  } catch (err) {
    console.error("Error initializing NeutralinoJS in main.tsx:", err);
  }
} else if (typeof window !== 'undefined' && !(window as any).NL_TOKEN) {
  console.debug("Modo Web/Cloudflare detectado — Operando con libSQL/Turso remoto y sql.js en memoria.");
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY} afterSignOutUrl="/">
      <App />
    </ClerkProvider>
  </React.StrictMode>,
);
